import { Component, OnDestroy, OnInit } from '@angular/core';
import {DateTime} from 'luxon';
import { AppointmentService } from '../../../shared/services/appointment.service';
import { ActivatedRoute, Router } from '@angular/router';
import { SubscriptionList } from '../../../shared/models/asp.types';
import { unsubscribeSubscriptions } from '../../../shared/services/util.service';
import { AppointmentType, IDeliveryAppointment, LocationType, ISalesAppointment, AppointmentStatus } from '@signal/asp-data-commons';
import { AspBannerService } from '../../../shared/services/asp-banner.service';
import * as util from '../../../shared/services/util.service'
import { Observable, combineLatest } from 'rxjs';
import { SettingsState } from 'src/app/modules/store/settings/settings.reducer';
import { Store } from '@ngrx/store';
import * as fromSettingsSelectors from "../../../store/settings/settings.selectors";
import { LoadSettings } from 'src/app/modules/store/settings/settings.actions';
@Component({
  selector: 'app-confirm-info-delivery',
  templateUrl: './confirm-info.component.html',
  styleUrls: ['./confirm-info.component.scss']
})
export class ConfirmInfoComponent implements OnInit, OnDestroy {
  view = 'confirm';
  appointment: IDeliveryAppointment;
  makeModelYear: string;
  detailMap: { [key: string]: string };
  id: string;
  subscriptions: SubscriptionList = {};
  time$: Observable<any>;
  estimatedDuration='';

  constructor(
    private readonly appointmentService: AppointmentService,
    private readonly route: ActivatedRoute,
    private readonly bannerService:AspBannerService,
    private readonly settingsState: Store<SettingsState>,
    private readonly router: Router) {
    this.settingsState.dispatch(new LoadSettings({department: 'sales'}));
    const urlState = this.router.getCurrentNavigation()?.extras?.state?.appt as ISalesAppointment;
    this.estimatedDuration=this.router.getCurrentNavigation()?.extras?.state?.totalDuration;
    if(urlState?.appointmentId) {
      this.appointment = urlState;
      this.setDetailMap(urlState);
    }
    else{
      this.subscriptions.query = this.route.queryParams.subscribe(params => {
        this.id = params.id;
        if (this.id) {
          this.subscriptions.getAppt = combineLatest([this.appointmentService.get(AppointmentType.DELIVERY, this.id),this.settingsState.select(fromSettingsSelectors.time)]).subscribe(([res,time]) => {
            if (res && res.data) {
              this.appointment = res.data;
              this.estimatedDuration = util.convertMinsToHourMins(time?.deliveryAppointmentDuration + time?.deliveryApptDuration);
              this.setDetailMap(res.data);
            }
          });
        }
      });
    }
  }

  ngOnInit(): void {
    this.bannerService.hide();
  }

  setDetailMap(appointmentDetails) {
    const isRemoteLocation = appointmentDetails.transportation.category === LocationType.REMOTE;

    const date = `${DateTime.fromISO(appointmentDetails.appointmentStartDate).toFormat('MMMM dd')}`;
    const time = appointmentDetails.timeSlotId;

    const dateTime = `${date} at ${time}`;

    const vehicle = appointmentDetails.vehicle;
    const advisorName = appointmentDetails.advisor?.displayName;
    const commentsFromDealer = appointmentDetails.appointmentComments ? this.getComment(appointmentDetails.appointmentComments, 'Comments-From-Dealer') : '';
    const dealerInternalComment =  appointmentDetails.appointmentComments ? this.getComment(appointmentDetails.appointmentComments, 'Dealer-Internal-Comments') : '';
    const additionalComments =  appointmentDetails.appointmentComments ? this.getComment(appointmentDetails.appointmentComments, 'Customer-Additional-Comments'): '';

    let customerAddress = '';
    if (isRemoteLocation) {
      const custAdd = appointmentDetails.dropOffAddress;
      customerAddress = `otherTexts.weWillBringTheCarTo:\n${custAdd.addressLine1}, ${custAdd.addressLine2 ? custAdd.addressLine2 + ', ' : ''} ${custAdd.city}, ${custAdd.state} - ${custAdd.zip}`;
    }

    this.makeModelYear =`${vehicle.year || ''} ${util.titleCase(vehicle.make) || ''} ${vehicle.model}`;


    const dealershipAddress = `${appointmentDetails.dealer.addressShort}`;

    this.detailMap = {
      'service.time': dateTime,
      'testDrive.vehicle': this.makeModelYear,
      'serviceSchedule.consultant': advisorName,
      'delivery.estimatedDuration': this.estimatedDuration,
      'delivery.commentsFromDealer': commentsFromDealer,
      'delivery.internalDealerComments': dealerInternalComment,
      'delivery.customerComments': additionalComments,
      'service.location': `${(isRemoteLocation ? customerAddress : dealershipAddress)}`
    };
    if(!commentsFromDealer) {
      delete this.detailMap['delivery.commentsFromDealer']
    }
    if(!dealerInternalComment) {
      delete this.detailMap['delivery.internalDealerComments']
    }
    if(!additionalComments) {
      delete this.detailMap['delivery.customerComments'];
    }
    if(appointmentDetails.appointmentStatus === AppointmentStatus.SAVED) {
      delete this.detailMap['service.time'];
      if(this.appointment?.advisorId === "-1"){
        delete this.detailMap['serviceSchedule.consultant'];
      }
    }

    const tradeInSummary = util.getTradeInVehicleSummaryText((appointmentDetails as any).tradeInVehicle);
    if (tradeInSummary) {
      this.detailMap['testDrive.tradeIn'] = tradeInSummary;
    }
  }

  getComment(data, field) {
    let returnComment = '';
    data.split(':::').forEach(comment=> {
      if(comment.includes(field)) {
        returnComment = comment.replace(`${field} - `, '').trim();
      }
    })
    return returnComment;
  }

  ngOnDestroy(): void {
    unsubscribeSubscriptions(this.subscriptions);
  }

}